
import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { SignIn } from 'actions/actionTypes';
import * as actions from 'actions/auth/manager';
import * as signInActions from 'actions/auth/signIn';

import { resetData } from 'actions/auth/signIn';
import { loadShopRecurringPaymentRequest } from 'actions/billing/recurringPayment';

import { callSignIn } from 'network/apis/auth/signIn';
import {signInFailure} from "actions/auth/manager";

function* signInRequestSaga() {
    try {
        const signIn = yield select(state => state.signIn);

        const response = yield call(callSignIn, signIn.id, signIn.password, signIn.remember);

        if (response.status === 200) {
            yield put(actions.signInSuccess(response.data));
            yield put(resetData());
            yield put(loadShopRecurringPaymentRequest());
        } else {
            yield put(actions.signInFailure('Failed Request')); // signInRequestFailure 호출
        }
    } catch(error) {
        yield put(actions.signInFailure(error.message));
    }
}

// Sign-In Sagas
export default function* root() {
    yield all([
        takeLatest(SignIn.SIGN_IN_REQUEST, signInRequestSaga),
    ]);
}